import React from 'react';

const SPRITE_URL = 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/';

function SecretPokemon({ pokemon }) {
  return (
    <div className="secret-pokemon">
      <span className="secret-label">Your Secret Pokemon</span>
      <img
        src={`${SPRITE_URL}${pokemon.id}.png`}
        alt={pokemon.name}
        className="secret-sprite"
        draggable={false}
      />
      <span className="secret-name">{pokemon.name}</span>
    </div>
  );
}

export default SecretPokemon;
